import { FC } from "react";
import { useWorkspaceStore } from "../../../../store/workspace/WorkspaceStore";
import { formatRevenueRange } from "../../../Workspace/View/CompanyList/utils";
import { getSegmentNameFromRange } from "../../../Workspace/View/MarketLandscape/utils";
import { ICPMarketDisplay } from "./ICPMarketDisplay";
import { DEFAULT_API_EMPLOYEE_RANGES } from "../../../Workspace/View/constants";

/**
 * Component that displays SOM (Serviceable Obtainable Market) data
 * Shows revenue and employee range information as chips
 */
export const ICPSOMDisplay: FC = () => {
  const revenueDistribution = useWorkspaceStore(
    (state) => state.icpRevenueDistribution
  );
  const employeeCountDistribution = useWorkspaceStore(
    (state) => state.icpEmployeeCountDistribution
  );
  const significantRevenue = revenueDistribution?.find(
    (item) => item.isSignificant
  );
  const significantEmployees = employeeCountDistribution?.find(
    (item) => item.isSignificant
  );

  const formattedRevenueRange = significantRevenue
    ? significantRevenue.revenueRangeMin === -1 &&
      significantRevenue.revenueRangeMax === -1
      ? "Unknown"
      : formatRevenueRange({
          min:
            significantRevenue.revenueRangeMin === -1
              ? null
              : significantRevenue.revenueRangeMin,
          max:
            significantRevenue.revenueRangeMax === -1
              ? null
              : significantRevenue.revenueRangeMax,
        })
    : null;

  const formattedEmployeeRange = significantEmployees
    ? getSegmentNameFromRange(
        {
          min: significantEmployees.employeesRangeMin || 0,
          max:
            significantEmployees.employeesRangeMax || Number.POSITIVE_INFINITY,
        },
        DEFAULT_API_EMPLOYEE_RANGES
      )
    : null;

  const sections = [
    {
      title: "EMPLOYEES",
      items: formattedEmployeeRange
        ? [
            {
              label: formattedEmployeeRange,
            },
          ]
        : [],
      emptyMessage: "No significant employee range found",
    },
    {
      title: "REVENUE",
      items: formattedRevenueRange
        ? [
            {
              label: formattedRevenueRange,
            },
          ]
        : [],
      emptyMessage: "No significant revenue range found",
    },
  ];

  return (
    <ICPMarketDisplay
      title="Serviceable Obtainable Market (SOM)"
      sections={sections}
      emptyMessage="No significant SOM data available"
      hasData={!!significantRevenue || !!significantEmployees}
    />
  );
};
